let _instance;

class CallHistoryService {
  constructor(){
    let lsHistory;
    if (localStorage) {
      lsHistory = JSON.parse(localStorage.getItem('call_history'));
    }
    this.history = { ...lsHistory };
  }

  add(objCallHistory){
    // console.log('CHS: add', objCallHistory, this.history);

    if (!this.history[objCallHistory.callerId]){
      this.history[objCallHistory.callerId] = [];
    }

    // only add if callId is not already there...
    const matchingCallId = this.history[objCallHistory.callerId].filter((callRecord)=>{
      return callRecord.callId == objCallHistory.callId;
    });

    if (matchingCallId.length === 0) {
      this.history[objCallHistory.callerId] = [].concat(objCallHistory, this.history[objCallHistory.callerId]);
      if (localStorage) {
        localStorage.setItem('call_history', JSON.stringify(this.history));
      }
    }
  }

  clearHistory(){
    //console.log('clear method running hopefully');
    this.history = {};
    if (localStorage) {
      localStorage.setItem('call_history', JSON.stringify(this.history));
    }
  }

  getHistory(){
    // converting object to array and sorting descending on lasttimestamp
    // console.log('HHHHH:', this.history);
    return Object.keys(this.history).map((callerId)=>{
      // console.log('#### this.history[callerId]', this.history[callerId]);
      return {
        lastName: this.history[callerId].reduce((p,c)=>{
          //console.log('RRR:', p, c )
          if (p && p.length > 0 ) return p;
          if (c.name && c.name.length > 0 ) return c.name;
          return '';
        }, ""),
        lastStatus: this.history[callerId][0].status,
        callerId: callerId,
        lastDirection: this.history[callerId][0].direction,
        lastTimestamp: this.history[callerId][0].timestamp,
        nbrCalls: this.history[callerId].length
      };
    }).sort((a,b)=>{
      return a.lastTimestamp < b.lastTimestamp;
    });
  }

  getHistoryDetail(callerId){
    // return a new array
    if(callerId && this.history[callerId]){
      return [ ...this.history[callerId]];
    } else {
      return [];
    }
  }

  static getInstance() {
    if (!_instance) {
      _instance = new CallHistoryService();
    }
    return _instance;
  }
}

//exporting
export default CallHistoryService;



// WEBPACK FOOTER //
// ./src/js/callHistoryService.js